enum Role {
	SalesRepresentative = 'salesrep',
	SalesManager = 'salesmanager'
}

export default Role;
